import { TradingOfferDetailContextType } from '../types/TradingOfferDetailContextType';

export const tradingOfferDetailInitValue: TradingOfferDetailContextType = {
  data: {
    societyId: '',
    societyName: '',
    offer: null,
    offerStatus: 'ACTIVE',
    offerReference: '',
    acceptanceHistory: [],
    tradingOfferOperations: [],
    priceContext: {
      currentOfferPrice: 0,
      lastTransactionPrice: 0,
      avgSellOffersPrice: 0,
      officialValuation: 0,
      userAvgBuyPrice: 0,
    },
    timelineSteps: [],
    sellerInfo: null,
    availableShares: 0,
    daysRemaining: 0,
    isAdmin: false,
    isExpired: false,
    isLoading: true,
    hasPartnerBuyer: false,
    purchaseQuantity: 1,
    commissionRate: 0.015,
  },
  actions: {
    handleGoBack: () => {},
    handlePurchaseQuantityChange: () => {},
    handleBuyShares: () => {},
    handleViewOtherOffers: () => {},
    handleGoToOperation: () => {},
  },
};
